import UpdatedSoon from "./UpdatedSoon";

const Contact = () => {
  return (
    // <div className="h-screen">
    //   <h1>This is Contact Page</h1>
    // </div>
    <UpdatedSoon/> 
  );
};

export default Contact;
